<template>
	<div class="MAM_queryList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-input size clearable v-model="queryForm.merchant_order_no" placeholder="交易流水号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="queryForm.merchant_number" placeholder="商户编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="queryForm.agent_no" placeholder="直属代理商编号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input size clearable v-model="queryForm.terminal_sn" placeholder="SN号"></el-input>
				</el-form-item>

				<el-form-item>
					<el-date-picker type="date" placeholder="交易开始时间" v-model="queryForm.start_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
					-
					<el-date-picker type="date" placeholder="交易结束时间" v-model="queryForm.end_time"
						value-format="yyyy-MM-dd" style="width: 150px;"></el-date-picker>
				</el-form-item>

				<el-form-item>
					<el-select size v-model="queryForm.brand_id" clearable placeholder="关联政策">
						<el-option v-for="item in brandList" :label="item.name" :value="item.id"
							:key="item.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>

					<el-button style="font-size: 12px;margin-left:20px" size="small" type="primary" icon="el-icon-download"
						:loading="downLoading" @click="handleDownLoad(queryForm)">导出数据</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card class="box-card header" shadow="hover" style="margin-top:20px">
			<div class="headerDivd">
				<div class="headerMoney">{{stockTable.last_total_money}}</div>
				<div style="margin:5px 0px;">昨日利润 (元)</div>
			</div>
			<div class="headerDivd">
				<div class="headerMoney">{{stockTable.transaction_total_monry}}</div>
				<div style="margin:5px 0px;">昨日交易总额 (元)</div>
			</div>
			<div class="headerDivd">
				<div class="headerMoney">{{stockTable.total_money_all}}</div>
				<div style="margin:5px 0px;">总利润额 (元)</div>
			</div>
			<div class="headerDivd">
				<div class="headerMoney">{{stockTable.count}}</div>
				<div style="margin:5px 0px;">总交易笔数</div>
			</div>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">

			<el-table :data="stockTable.list" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" prop="merchant_order_no"
					label="交易流水号"></el-table-column>
				<el-table-column header-align="center" align="center" prop="transaction_time"
					label="交易时间"></el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_number"
					label="商户编号"></el-table-column>
				<el-table-column header-align="center" align="center" prop="merchant_name"
					label="商户名称"></el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="直属代理商编号"></el-table-column>
				<el-table-column header-align="center" align="center" prop="nickname" label="直属代理商名称"></el-table-column>
				<el-table-column header-align="center" align="center" prop="terminal_sn" label="SN"></el-table-column>
				<el-table-column header-align="center" align="center" prop="name" label="关联政策"></el-table-column>
				<el-table-column header-align="center" align="center" prop="transaction_money"
					label="交易金额"></el-table-column>
				<el-table-column header-align="center" align="center" prop="transaction_fee" label="手续费"></el-table-column>
				<el-table-column header-align="center" align="center" prop="transaction_settle_amt"
					label="结算金额"></el-table-column>
				<el-table-column header-align="center" align="center" prop="pay_type" label="交易类型"></el-table-column>
				<el-table-column header-align="center" align="center" prop="card_type" label="卡类型"></el-table-column>
				<el-table-column header-align="center" align="center" prop="total_money" label="利润额"></el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>

	</div>
</template>

<script>
	import paginations from '../../../components/pagination/paginations';
	export default {
		name: "differenceShareProfit",
		data() {
			return {
				queryForm: {
					user_id: this.$route.query.user_id,
					is_list: 2,
					start_time:'',
					end_time:'',
					merchant_order_no:'',
					merchant_number:'',
					agent_no:'',
					terminal_sn:'',
					brand_id:'',
				},
				stockTable: { //列表
					list: [],
					last_total_money: 0,
					transaction_total_monry: 0,
					total_money_all: 0,
					count: 0,
				},
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 0, //总数
				},
				loading: true,
				brandList: [],
				downLoading:false
			}
		},
		mounted() {
			this.handleDefaultTime();
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
				user_id: this.$route.query.user_id,
				is_list: 2,
				start_time:this.queryForm.start_time,
				end_time:this.queryForm.end_time
			})
			this.getBrand()
		},
		components: {
			paginations,
		},
		methods: {
			handleDownLoad(params) { //导出
				let reqData = {
					type: 11,
					value: JSON.stringify(params)
				};
			
				this.downLoading = true;
				this.$api.post('export/add', reqData, res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.downLoading = false;
					} else {
						this.$message.error(res.msg);
						this.downLoading = false;
					}
			
				})
			},
			handleDefaultTime() { //默认获取三十天
			    let date =this.$moment().endOf('day').format('x');
			    this.queryForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD");
			    this.queryForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD");
			},
			// 获取关联政策
			getBrand() {
				this.$api.post('brand/brand_list', {}, res => {
					if (res.code == 0) {
						this.brandList = res.data.list;
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				queryForm.is_list = 2;
				// 表单提交
				this.getData(queryForm);
			},
			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.$api.post("userteamleader/getUserTeamProfitLogList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.page.total = data.list.total; //总数
						this.stockTable.list = res.data.list.data;

						this.stockTable.last_total_money = res.data.last_total_money;
						this.stockTable.transaction_total_monry = res.data.transaction_total_monry;
						this.stockTable.total_money_all = res.data.total_money_all;
						this.stockTable.count = res.data.count;
					} else {
						this.$message.error(res.msg);
					}
					// //渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}

	.header>.el-card__body {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.headerDivd {
		padding-right: 50px;
		font-size: 14px;
		color: #E6A23C;
	}

	.headerMoney {
		font-size: 28px;
		font-weight: bold;
	}
</style>